{
  "title": "Flock of Familiars",
  "source": "Lost Laboratory of Kwalish",
  "levelAndSchool": "2nd-level conjuration",
  "level": 2,
  "castingTime": "1 minute",
  "range": "Touch",
  "components": "V, S",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You temporarily summon three familiars – spirits that take animal forms of your choice. Each familiar uses the same rules and options for a familiar conjured by the Find Familiar spell. All the familiars conjured by this spell must be the same type of creature (celestials, fey, or fiends; your choice). If you already have a familiar conjured by the Find Familiar spell or similar means, then one fewer familiars are conjured by this spell.",
    "Familiars summoned by this spell can telepathically communicate with you and share their visual or auditory senses while they are within 1 mile of you.",
    "When you cast a spell with a range of touch, one of the familiars conjured by this spell can deliver the spell, as normal. However, you can cast a touch spell through only one familiar per turn.",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, you conjure an additional familiar for each slot level above 2nd."
  ],
  "spellLists": ["warlock", "wizard"]
}
